import React, { useEffect } from 'react';
import { useWeatherStationsList } from '@js/api';
import { FormProvider, useForm } from 'react-hook-form';
import SelectField from '../SelectField/SelectField';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import './BestVarietiesForm.css';
import Select from '@components/Select/Select';
import { PRECOCITY, SOIL_TYPE, TYPE } from '@components/BestVarieties/constants';

function BestVarietiesForm({ params, setParams, isError }) {
  const yupSchema = yup.object().shape({
    weather_station: yup.string().required(),
    precocity: yup.string().required(),
    soil_type: yup.string().required(),
    type: yup.string().required()
  })
  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(yupSchema),
    defaultValues: {
      ...params
    }
  });
  const onValid = (data) => {
    setParams(data);
  };

  const { data } = useWeatherStationsList();
  const stationsOptions = data?.reduce((options, value) => {
    return [
      ...options,
      {
        value: value.title,
        label: value.title
      }
    ];
  }, []);

  useEffect(() => {
    const selects = async () => {
      await Select();
    }
    selects();
  }, []);

  return (
    <FormProvider {...methods}>
      <section className="BestVarietiesForm">
        <picture className="BestVarietiesForm-image">
          <img src={window.IMG_EXPERT_SYSTEM} alt="systeme-expert" />
        </picture>
        <div className="BestVarietiesForm-rightBlock">
          <h1 className="BestVarietiesForm-title typo-brand-page-title">
            Consultez et choisissez les meilleures variétés adaptées à vos besoins
          </h1>
          { isError &&
            <div className="w-full mb-6 alert alert--danger">
              <span>Une erreur est survenue. Impossible de récupérer les variétés.</span>
            </div>
          }
          <form
            className="BestVarietiesForm-form"
            onSubmit={methods.handleSubmit(onValid)}>
              <SelectField
                register={methods.register}
                id="specie"
                label="Espèce"
                values={[
                  {
                    value: 'sunflower',
                    label: 'Tournesol'
                  },
                ]}
                defaultValue="Tournesol"
                required />
              <SelectField
                register={methods.register}
                id="weather_station"
                label="Localisation (ville, département)"
                values={stationsOptions}
                searchable
                required />
              <SelectField
                register={methods.register}
                id="precocity"
                label="Précocité"
                values={PRECOCITY}
                required />
              <SelectField
                register={methods.register}
                id="soil_type"
                label="Type de sol"
                values={SOIL_TYPE}
                required />
              <SelectField
                register={methods.register}
                id="type"
                label="Linoléique / oléique"
                values={TYPE}
                required />
              <button
                type="submit"
                className="btn btn--rounded"
                disabled={!methods.formState.isValid}>
                  Rechercher
              </button>
          </form>
        </div>
      </section>
    </FormProvider>
  );
}

export default BestVarietiesForm;
